module.exports = __webpack_public_path__ + "img/BookPay.46a1165d.svg";